<template>
  <div class="wrapper">
    <el-dialog
      :title="rowId ? '编辑商品' : '新增商品'"
      :visible.sync="showAddOrEdit"
      width="800px"
      :before-close="cancelFun"
    >
      <el-form ref="form" :model="formData" class="wrapper-form" label-width="120px">
        <el-form-item label="品牌" prop="goodsBrand" :rules="rules">
          <el-select
              style="width: 400px"
              v-model="formData.goodsBrand"
              placeholder="请选择"
              size="small"
              clearable
          >
            <el-option v-for="item in brandList" :key="item.enumCode" :label="item.enumText" :value="item.enumCode" />
          </el-select>
        </el-form-item>
        <el-form-item label="机型" prop="model" :rules="rules">
          <el-select style="width:400px" v-model="formData.model" placeholder="请选择" size="small" clearable>
            <el-option v-for="item in modelList" :key="item.enumCode" :label="item.enumText" :value="item.enumCode" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="goodsType == dict.EnumGoodsType.C3" label="内存" prop="memory" :rules="rules">
          <el-select style="width:400px" v-model="formData.memory" placeholder="请选择" size="small" clearable>
            <el-option v-for="item in memoryList" :key="item.enumCode" :label="item.enumText" :value="item.enumCode" />
          </el-select>
        </el-form-item>
        <el-form-item label="颜色" prop="colorList" :rules="rules">
          <el-select style="width:400px" v-model="formData.colorList" placeholder="请选择" size="small" multiple clearable>
            <el-option v-for="item in colorList" :key="item.enumText" :label="item.enumText" :value="item.enumCode" />
          </el-select>
        </el-form-item>
        <el-form-item label="封面图" prop="coverImage" :rules="rules">
          <FileUpload :name.sync="formData.coverImage" :url="formData.coverImageUrl"></FileUpload>
        </el-form-item>
        <el-form-item label="官网价" prop="officialPrice" :rules="rules">
          <el-input-number style="width:400px" size="small" v-model="formData.officialPrice" :precision="2" :step="0.01" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="买断金" prop="buyoutPrice" :rules="rules">
          <el-input-number style="width:400px" size="small" v-model="formData.buyoutPrice" :precision="2" :step="0.01" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="全新售价" prop="minPrice" :rules="rules">
          <div>
            <el-input-number style="width:190px" size="small" v-model="formData.minPrice" :precision="2" :step="0.01" :min="0"></el-input-number> ~
            <el-input-number style="width:190px" size="small" v-model="formData.maxPrice" :precision="2" :step="0.01" :min="0"></el-input-number>
          </div>
        </el-form-item>
        <el-form-item label="二手售价" prop="oldMinPrice" :rules="rules">
          <div>
            <el-input-number style="width:190px" size="small" v-model="formData.oldMinPrice" :precision="2" :step="0.01" :min="0"></el-input-number> ~
            <el-input-number style="width:190px" size="small" v-model="formData.oldMaxPrice" :precision="2" :step="0.01" :min="0"></el-input-number>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="cancelFun">取 消</el-button>
        <el-button type="primary" size="small" @click="submitFun">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getBrandListAPI, getAttrListAPI, getDetailAPI, addAPI, editAPI } from './api';
import { EnumGoodsType } from "@/enum/dict/index.js";
import FileUpload from '@/components/file-upload/index.vue';

export default {
  name: 'StoreGoodsAddOrEdit',
  components: { FileUpload },
  props: {
    showAddOrEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: null,
    },
    goodsType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      rules: [{ required: true, message: '该项不能为空', trigger: 'blur' }],
      dict: {
        EnumGoodsType
      },
      brandList: [],
      modelList: [],
      memoryList: [],
      colorList: [],
      formData: {
        goodsType: '',
        goodsBrand: '',
        model: '',
        memory: '',
        colorList: [],
        coverImage: '',
        officialPrice: '',
        minPrice: '',
        maxPrice: '',
        oldMinPrice: '',
        oldMaxPrice: '',
        buyoutPrice: ''
      }
    }
  },
  mounted() {
    this.getBrandList();
    this.getModelList();
    if (this.goodsType == EnumGoodsType.C3) {
      this.getMemoryList();
    }
    this.getColorList();
    if (this.rowId) this.getGoodsDetail();
  },
  methods: {
    async getBrandList() {
      this.brandList = await getBrandListAPI({
        goodsType: this.goodsType,
      });
    },
    async getModelList() {
      let params = { goodsType: this.goodsType, groupCode: 'model' };
      const res = await getAttrListAPI(params);
      this.modelList = res || [];
    },
    async getMemoryList() {
      let params = { goodsType: this.goodsType, groupCode: 'memory' };
      const res = await getAttrListAPI(params);
      this.memoryList = res || [];
    },
    async getColorList() {
      let params = { goodsType: this.goodsType, groupCode: 'color' };
      const res = await getAttrListAPI(params);
      this.colorList = res || [];
    },
    async getGoodsDetail() {
      this.formData = await getDetailAPI(this.rowId);
    },
    submitFun() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.formData.goodsType = this.goodsType;
          if (this.formData.id) {
            editAPI(this.formData).then(() => {
              this.$message.success('编辑成功');
              this.$emit("closeDialog", true);
            })
          } else {
            addAPI(this.formData).then(() => {
              this.$message.success('新增成功');
              this.$emit("closeDialog", true);
            })
          }
        }
      })
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .wrapper-form {
    max-height: 400px;
    overflow-y: scroll;
  }
  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }
  /*打开时文字位置设置*/
  .switch .el-switch__label--right {
    z-index: 1;
  }
  /* 调整打开时文字的显示位子 */
  .switch .el-switch__label--right span {
    margin-left: 5px;
  }
  /*关闭时文字位置设置*/
  .switch .el-switch__label--left {
    z-index: 1;
  }
  /* 调整关闭时文字的显示位子 */
  .switch .el-switch__label--left span {
    margin-left: 20px;
  }
  /*显示文字*/
  .switch .el-switch__label.is-active {
    display: block;
  }
  /* 调整按钮的宽度 */
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 55px !important;
    margin: 0;
  }
}
</style>
<style lang="scss" scoped>
.wrapper /deep/ {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
  }
  .avatar {
    width: 148px;
    height: 148px;
    display: block;
  }
}
</style>
